import React, { useEffect, useState } from "react";
import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";
import { getBranchLabelFromCode, getClassLevelLabelFromCode } from "utils/schoolUtils";
import { ClassData } from "types/classTypes";
import AssignSubjectsModal from "./AssignSubjectsModal";

type SchoolCycle = "preschool" | "primary_school" | "secondary_school" | "high_school";

export interface ClassLevel {
  id: string;
  name: string;
  labelKey: string;
  schoolCycle: SchoolCycle;
}

export interface Branch { id: string; labelKey: string; }

export interface TabDetailClassProps {
  detailClass: ClassData | null;
  studentsCount?: number; // fallback if noOfStudents isn’t provided
}

const TabDetailClass: React.FC<TabDetailClassProps> = ({ detailClass, studentsCount = 0 }) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (detailClass) {
      getSubjectsModal(detailClass);
    }
  }, [detailClass]);

  const items = [
    { key: "name", label: t("class"), children: detailClass?.name || "—" },
    { key: "code", label: t("class_code"), children: detailClass?.code || "—" },
    { key: "section", label: t("section"), children: detailClass?.classLevel?.schoolCycle ? t(detailClass.classLevel.schoolCycle) : "—" },
    { key: "level", label: t("level"), children: detailClass?.classLevel?.labelKey ? getClassLevelLabelFromCode(detailClass.classLevel.labelKey) : "—" },
    { key: "branch", label: t("branch"), children: detailClass?.branch ? getBranchLabelFromCode(detailClass.branch.labelKey, t) : t("no_branch") },

    // { key: "students", label: t("no_of_students"), children: detailClass?.noOfStudents ?? studentsCount ?? 0 },
  ];

  const [subjects, setSubjects] = useState<any>([]);
  const getSubjectsModal = (record: ClassData) => {
    const extractedSubjects =
      record.classSubject?.map((cs) => ({
        name: cs.subject?.name || t("unknown_subject"),
        coefficient: cs.coefficient,
        colorCode: cs.subject?.colorCode,
        code: cs.subject?.code,
        parent: cs.subject?.parent ?? null,
      })) || [];

    setSubjects(extractedSubjects);
  };



  return (

    <div className="row g-3">
      <div className="col-12 col-lg-6">
        <div className="card shadow-sm h-100">
          <div className="card-header d-flex align-items-center gap-2">
            <i className="ti ti-eye " />
            <h6 className="mb-0">{t("details")}</h6>
          </div>

          <div className="card-body p-0" style={{ maxHeight: "60vh", overflowY: "auto" }}>
            <ul className="list-group list-group-flush">
              {items.map((it: any) => (
                <li
                  key={it.key}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  <span className="fw-semibold">{it.label}</span>
                  <span className="text-muted">{it.children}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div className="card shadow-sm h-100">
          <div className="card-header d-flex align-items-center gap-2">
            <i className="ti ti-book " />
            <h6 className="mb-0">{t("class_subjects")}</h6>
            <span className="badge rounded-pill ms-2" style={{ backgroundColor: "#6C3DF4" }}>
              {subjects?.length || 0}
            </span>
          </div>

          <div className="card-body" style={{ maxHeight: "60vh", overflowY: "auto" }}>
            <AssignSubjectsModal isModal={false} subjects={subjects} className="mb-0" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabDetailClass;
